import { useLayoutEffect } from 'react';
import { useHistory } from 'react-router';

const useAuthorizationNormal = (): void => {
  const history = useHistory();

  useLayoutEffect(() => {
    const isLogin = JSON.parse(sessionStorage.getItem('member_info') || '{}');
    if (!isLogin.result) {
      sessionStorage.clear();
      const url = '/';
      history.push(url);
    }
  }, [history]);
};

export default useAuthorizationNormal;
